import fetch from '@/utils/fetch';
import * as API from '@/commons/http-api';

/**
 * 示例模块
 */
export default {
  namespace: 'example',
  state: {
    switchCheck: false,
    dataSource: [],
  },
  reducers: {
    updateSwitch(state, action) {
      return {
        ...state,
        switchCheck: action.payload,
      };
    },
    setDataSource(state, action) {
      return {
        ...state,
        dataSource: action.payload,
      };
    },
  },
  effects: {
    *getDataSource(action, { put }) {
      const res = yield fetch.get(API.EXAMPLE_LIST);
      yield put({
        type: 'setDataSource',
        payload: res.list,
      });
    },
  },
};
